
import { Base } from '../base-component';

import './table-popup.component.scss';

import * as $ from 'jquery';

export class TablePopup extends Base {

	tables: Element[];

	modals: Element[];
	modalContent: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		this.tables = Array.from(this.element.querySelectorAll('.table'));

		this.modals = Array.from(this.element.querySelectorAll('.js-table-popup-modal'));
		this.modalContent = Array.from(this.element.querySelectorAll('.table-popup__modal-content'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-table-popup-modal-open'));
		this.closeButton = this.element.querySelector('.js-table-popup-modal-close');
	}

	bindEvents() {

		// this.tables.map((item) => item.addEventListener('mousewheel', (event) => {
		// 	this.scrollHorizontally(event);
		// }));

		// this.tables.map((item) => item.addEventListener('DOMMouseScroll', (event) => {
		// 	this.scrollHorizontally(event);
		// }));

		// this.tables.map((item) => item.addEventListener('onmousewheel', (event) => {
		// 	this.scrollHorizontally(event);
		// }));

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
		}));

		this.modalContent.map((item) => item.addEventListener('scroll', (event) => {
			this.staticHeader();
		}));

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {

		let element: Element = event.target;
		let modalId = element.getAttribute('data-modal');

		if (!modalId) {
			let parentElement = $(element).closest('.js-table-popup-modal-open');
			modalId = parentElement.attr('data-modal');
		}
		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	closeModal() {

		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModal() {
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

	scrollHorizontally(event) {

		event = window.event || event;

		let delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

		event.currentTarget.scrollLeft -= (delta * 40); // Multiplied by 40

		event.preventDefault();

	}

	staticHeader() {
		const popup = document.querySelector('.js-table-popup-modal-window');
		const table = document.querySelectorAll('.static_header');
		const tableHead = document.querySelectorAll('.static_header thead');
		const tableBody = document.querySelectorAll('.static_header tbody');
		const fixedHeader = document.querySelectorAll('.static_header .fixed');
		console.log(table);
		// const offset = table.getBoundingClientRect();
		for (let i = 0; i < table.length; ++i) {
			const offsetBody = tableBody[i].getBoundingClientRect();
			const windowOffset = popup.getBoundingClientRect();
			if (windowOffset.top >= offsetBody.top) {
				table[i].classList.add('static_header__top');
				tableHead[i].classList.add('fixed');
				if (popup.clientWidth > 767) {
					tableHead[i].setAttribute('style', 'top: ' + ((windowOffset.top + 40) - offsetBody.top) + 'px !important;');
				} else {
					tableHead[i].setAttribute('style', 'top: ' + (windowOffset.top - offsetBody.top) + 'px !important;');
				}
			} else {
				table[i].classList.remove('static_header__top');
				tableHead[i].classList.remove('fixed');
				tableHead[i].setAttribute('style', '');
			}

			if (windowOffset.top >= offsetBody.bottom) {
				table[i].classList.remove('static_header__top');
				tableHead[i].classList.remove('fixed');
				tableHead[i].setAttribute('style', '');
			}
		}
		if (fixedHeader != null) {
			$(tableBody).find('tr').first().children().each(function (i, e) {
				$($(fixedHeader).find('tr').children()[i]).width($(e).width() - 1);
			});
		}
	}


}



// WEBPACK FOOTER //
// ./components/table-popup/table-popup.component.ts